import { Box, Skeleton } from '@mui/material'
import { EmtAvatar, EmtIcon, EmtTypography } from 'emt-components-v2'

interface GenericBoxProps {
  title: string
  subtitle?: string
  icon?: string
  image?: string
  textActionText?: string
  actionText?: () => void
  isLoading?: boolean // add loading prop
  reverseText?: boolean
  disabled?: boolean
}

const GenericBox: React.FC<GenericBoxProps> = ({
  title,
  subtitle,
  icon,
  image,
  textActionText,
  actionText,
  isLoading,
  reverseText,
  disabled,
}) => {
  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{
          width: '100%',
          height: 70,
          borderRadius: '16px',
          padding: '14px 16px',
        }}
      />
    )
  }

  return (
    <Box
      sx={{
        minWidth: 0,
        width: '100%',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '16px',
          padding: '12px',
          border: `1px solid #E8E8EA`,
          backgroundColor: '#fff',
          borderRadius: '16px',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0, justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
            <Box
              className="EmtInlineCard-image-wrapper"
              sx={{
                position: 'relative',
                width: '40px',
                height: '40px',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
                backgroundColor: '#FBF1FE',
                borderRadius: '12px',
                color: '#AE59C6',
              }}
            >
              {image ? (
                <EmtAvatar
                  sx={{ flexShrink: 0, height: '100%!important', width: '100%', borderRadius: '12px' }}
                  size="large"
                  src={image}
                />
              ) : icon ? (
                <EmtIcon className={icon} size="small" />
              ) : null}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: reverseText ? 'column-reverse' : 'column',
                minWidth: 0,
              }}
            >
              <EmtTypography
                variant="body2"
                fontWeight="700"
                sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', flexShrink: 1 }}
              >
                {title}
              </EmtTypography>
              {subtitle && (
                <Box sx={{ display: 'flex', gap: '4px' }}>
                  <EmtTypography
                    variant="body2"
                    color="#A5A3A9"
                    sx={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}
                  >
                    <span>{subtitle}</span>
                  </EmtTypography>
                </Box>
              )}
            </Box>
          </Box>
          {actionText && (
            <EmtTypography
              variant="body2"
              color="#AE59C6"
              sx={{
                cursor: 'pointer',
                display: 'inline-block',
                textDecoration: 'underline',
              }}
              onClick={actionText}
            >
              {textActionText || 'Modifier'}
            </EmtTypography>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default GenericBox
